import { getErrorMessage } from '@/lib/queries'
import { destroySessionToken } from '@/stores/session'
import { MESSAGE } from '@repo/constants'

// Refusals the login screen explains after signing the driver out. A plain
// expired or revoked session needs no words: the login form says enough.
const EXPLAINED_SIGN_OUT_REASONS: ReadonlySet<string> = new Set([MESSAGE.TENANT_INACTIVE])

export const signOutReason = (err: unknown) => {
  const code = getErrorMessage(err, '')
  return EXPLAINED_SIGN_OUT_REASONS.has(code) ? code : undefined
}

export async function handleInvalidSession(err?: unknown) {
  destroySessionToken()
  const params = new URLSearchParams({ redirect: window.location.pathname })
  const reason = signOutReason(err)
  if (reason) params.set('reason', reason)
  window.location.replace(`/login?${params.toString()}`)
}
